import { createContext, FC, useContext, useState } from 'react'

enum SchedulingStatus {
  INITIAL = 'initial',
  FETCHING = 'fetching',
  IDLE = 'idle',
}

interface State {
  setStatus: (status: SchedulingStatus) => void
  status: SchedulingStatus
}

const defaultState: State = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setStatus: (status: SchedulingStatus) => undefined,
  status: SchedulingStatus.INITIAL,
}

const context = createContext<State>(defaultState)
const { Provider } = context

const SchedulingStateProvider: FC = ({ children }) => {
  const [status, setStatus] = useState<SchedulingStatus>(SchedulingStatus.INITIAL)

  const value: State = {
    setStatus,
    status,
  }

  return <Provider value={value}>{children}</Provider>
}

const useSchedulingState = () => useContext(context)

export { SchedulingStateProvider, SchedulingStatus, useSchedulingState }
